<div class="dialog">
  <h4 mat-dialog-title>{{ 'common_modify' | translate }}</h4>
  <form #form="ngForm" [appEnterToSave]="data">
    <mat-form-field>
      <mat-label>{{ 'dialog_edit_engin_field_engin' | translate }}</mat-label>
      <input matInput type="text" [(ngModel)]="data.displayName" name="Name" disabled />
    </mat-form-field>
    <mat-form-field>
      <mat-label *ngIf="data?.displayAsDay">{{ 'dialog_edit_engin_field_quantity_days' | translate }}</mat-label>
      <mat-label *ngIf="data?.isAtelier">{{ 'dialog_edit_engin_field_quantity_engins' | translate }}</mat-label>
      <mat-label *ngIf="!data?.displayAsDay && !data?.isAtelier">{{ 'dialog_edit_engin_field_quantity_hours' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="data.quantity" name="quantity" min="0" step="any" cdkFocusInitial required />
      <mat-error *ngIf="!data?.quantity" [innerHTML]="'common_error_quantity_required' | translate"></mat-error>
    </mat-form-field>
    <div mat-dialog-actions>
      <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button [mat-dialog-close]="data" color="accent" [disabled]="!form.valid">{{ 'common_btn_save' | translate }}</button>
    </div>
  </form>
</div>
